/**
 * Language Model Interface
 * Framework-agnostic TypeScript interface
 */

export interface Language {
  id?: number;
  language_id?: number;
  language_name: string;
  language?: string;
  language_code?: string;
  created_at?: string;
  updated_at?: string;
  active?: number | boolean;
  program_id?: number;
}

export interface LanguageFormData {
  id?: number;
  language_id?: number;
  language_name: string;
  language_code?: string;
}

export interface LanguageApiResponse {
  data: {
    languages: Language[];
  };
  message?: string;
  success?: boolean;
}
